// 使 $axios 可以在 services 使用
import { setClient } from '~/xhr';

export default ({ app, $axios, $log }) => {
  $axios.defaults.timeout = 50000;
  $axios.defaults.withCredentials = true;
  setClient(app.$axios);

  if (process.env.NUXT_ENV_MODE === 'dev') {
    // $axios.onRequest((request) => {
    //   console.log(`[${new Date().toJSON()}]请求接口：${request.url}`);
    // });
  }

  $axios.onRequest((request) => {
    if (
      process.client &&
      window.location.origin.includes('bigoapp.tv') &&
      process.env.NUXT_ENV_MODE === 'prod'
    ) {
      request.url = request.url.replace('bigo.tv', 'bigoapp.tv');
    }
  });

  $axios.onResponse((response) => {
    if ($log) {
      $log.info('axios request', {
        msg: `[${response.status}]${response.request.path ||
          response.config.url}`
      });
    }
    return response.data;
  });

  $axios.onError((err) => {
    if ($log) {
      $log.error('axios error', {
        msg: `
        err status: [${err.status}]
        | err request path :${err.request?.path}
        | err message: ${err.message},
        | err response: ${err.response && err.response.data}
      `
      });
    }
  });
};
